import PortfolioPage from "./PortfolioPage";

export default function ModelPortfolioPage() {
  return (
    <PortfolioPage
      pageType="model-portfolio"
      title="Model Portfolio"
      subtitle="Explore our fashion and editorial makeup looks"
    />
  );
}
